import { CloseCircleOutlined } from '@ant-design/icons';
import AllCheckboxGroup from "@components/all-checkbox-group";
import { FilterIcon } from "@components/icons/Icons";
import { IssueFilterDrawer } from "@components/issues-filter-drawer";
import { SCREEN, useWindowSize } from "@components/window-size-provider";
import {formatNumber, formatTitleCase} from "@lib/format";
import { IssueFilters } from "@mwServices/Issue";
import { Button, Checkbox, Col, Collapse, Row, Space, Spin } from "antd";
import React, {useEffect, useMemo, useState} from "react";
import { isEqual, sortBy } from "underscore";
import {fixFilterObjectEmptyArrays} from "@components/issues-filter-drawer/IssueFilterDrawer";


const { Panel } = Collapse;

const FiltersContent = ({ publishers = [], filters, setFilters }: any) => {
    return (
        <div className={`partner-portal-drawer`}>

            <Row>
                <Col span={24}>
                    <div className="font-18 font-bold">Filter by:</div>
                    <Collapse
                        className="filtersAccordion"
                        defaultActiveKey={[1, 2, 3, 4]}
                        expandIconPosition={"end"}
                        ghost
                    >
                        <Panel header="# 1s" key={1}>
                            <Space direction="vertical">
                                <Checkbox
                                    checked={!!filters?.justFirst}
                                    onChange={(event) => setFilters({
                                        ...filters,
                                        justFirst: event.target.checked
                                    })}
                                >{formatTitleCase('Only Show #1s')}
                                </Checkbox>
                            </Space>
                        </Panel>
                        
                        <Panel header="Only Show New / Updated / Pushed" key={2}>
                            <Space direction="vertical">
                                <Checkbox
                                    checked={!!filters?.onlyShowNew}
                                    onChange={(event) => setFilters({
                                        ...filters,
                                        onlyShowNew: event.target.checked
                                    })}
                                >{formatTitleCase('New')}
                                </Checkbox>
                                <Checkbox
                                    checked={!!filters?.onlyShowUpdated}
                                    onChange={(event) => setFilters({
                                        ...filters,
                                        onlyShowUpdated: event.target.checked
                                    })}
                                >{formatTitleCase('Updated')}
                                </Checkbox>
                                <Checkbox
                                    checked={!!filters?.onlyShowPushed}
                                    onChange={(event) => setFilters({
                                        ...filters,
                                        onlyShowPushed: event.target.checked
                                    })}
                                >{formatTitleCase('Pushed')}
                                </Checkbox>
                            </Space>
                        </Panel>

                        <Panel header="Regular / Variants" key={3}>
                            <Space direction="vertical">
                                <Checkbox checked={!!filters?.showRegular}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            showRegular: e.target.checked
                                        })}
                                >
                                    {formatTitleCase('Regular')}
                                </Checkbox>
                                <Checkbox
                                    checked={!!filters?.showVariants}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            showVariants: e.target.checked
                                        })}
                                >{formatTitleCase('Variants')}</Checkbox>
                            </Space>
                        </Panel>

                        <Panel header="Publisher" key={4}>
                            <Space direction="vertical">
                                <Checkbox
                                    checked={publishers.length === filters.publishers.length}
                                    onChange={(event) => {
                                        setFilters({...filters, publishers: event.target.checked ? publishers.map(item => item.value) : []})
                                    }}
                                >All</Checkbox>
                                {publishers.map((publisher,i) => (
                                    <Checkbox
                                        key={i}
                                        checked={!filters.publishers || filters.publishers.indexOf(publisher.value) !== -1}
                                        onChange={(event) => {
                                            if(!filters.publishers && !event.target.checked) {
                                                setFilters({...filters, publishers: publishers.map(item => item.value).filter(item => item !== publisher.value)});
                                            }else if(filters.publishers) {
                                                let filtered: any = filters.publishers ? [...filters.publishers] : [];
                                                if (event.target.checked) {
                                                    filtered = [...filtered, publisher.value]
                                                } else {
                                                    filtered = !!filters.publishers ? filters.publishers.filter(item => item !== publisher.value) : [];
                                                }
                                                setFilters({...filters, publishers: filtered});
                                            }
                                        }}
                                    >
                                        {formatTitleCase(publisher.label, 'Unknown Publisher')}
                                    </Checkbox>
                                ))}

                            </Space>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </div>
    );
};

const FiltersButton = ({ publishers = [], filters, setFilters, onFilterClear }) => {
    const windowDimensions = useWindowSize();
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const [newFilters, setNewFilters] = useState<IssueFilters>(filters);
    const [showClearFilter, setShowClearFilter] = useState<boolean>(false);

    useEffect(() => {
        if (!isEqual(newFilters, filters))  setNewFilters(filters);
    }, [filters]);

    const onClose = () => {
        setNewFilters(filters);
        setShowFilters(false);

        if (!isEqual(newFilters, filters))  setShowClearFilter(true);
    };
    
    const handleFilterClear = () => {
        setShowClearFilter(false);
        onFilterClear();
    };

    return (
        <div className={`pp-filter-button`}>
            <Space direction={`horizontal`} size={12}>
                {showClearFilter &&
                    <Button className={`clear-btn`} onClick={handleFilterClear} size={"large"}>
                        Clear
                        <CloseCircleOutlined />
                    </Button>
                }
                <Button className="greyButton" size={"large"} onClick={() => setShowFilters(true)}>
                    {windowDimensions.up(SCREEN.SM)
                        && (<span className="filterButtonText">Filter / Sort</span>)}
                    <FilterIcon className="font-12" />
                </Button>
            </Space>

            <IssueFilterDrawer
                visible={showFilters}
                onClose={onClose}
                onSearch={() => {
                    setShowFilters(false);
                    const fixedFilters = fixFilterObjectEmptyArrays(
                        newFilters,
                        filters,
                        ['publishers']
                    );

                    if(!isEqual(fixedFilters, filters)) {
                        setFilters(fixedFilters);
                        setShowClearFilter(true);
                    }else if(!isEqual(fixedFilters, newFilters)) {
                        setNewFilters(fixedFilters);
                    }
                }}>
                <FiltersContent filters={newFilters} setFilters={setNewFilters} publishers={publishers}/>
            </IssueFilterDrawer>
        </div>
    )
};

export default FiltersButton;